import monitor, { EVENT_TYPES } from '../../../../../../service/bigquery';
import { convertTagPageId } from '../../convertTagPageId';
import { getIdeaPageName } from '../getIdeaPageName';

export const tagLinkClicked = ({ componentName, pageTagType, pageTagId, tagId }) => {
    const sendData = {
        page: {
            name: getIdeaPageName(pageTagType, pageTagId),
            component: {
                name: componentName,
            },
            element: {
                name: convertTagPageId(tagId),
            },
        },
        feature: {
            name: 'logo_maker',
            parent_name: 'makers_project',
        },
    };

    monitor.track(EVENT_TYPES.IDEA_RELATED_TAG_CLICKED, sendData);
};
